"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeUpdateStatus = exports.serializeProgressBreakdown = void 0;
const lodash_1 = __importDefault(require("lodash"));
const Pipeline = __importStar(require("./Pipeline"));
/** sort() comparator for descriptions, based on their defined order. */
const compareStepDescriptions = (a, b) => {
    if (a === b) {
        return 0;
    }
    if (Pipeline.ALL_STEP_DESCRIPTIONS.indexOf(a) < Pipeline.ALL_STEP_DESCRIPTIONS.indexOf(b)) {
        return -1;
    }
    return 1;
};
/**
 * Converts {@link Pipeline.TypeCheckedProgressBreakdown} to {@link Pipeline.ProgressBreakdown},
 * preserving correct order.
 */
const serializeProgressBreakdown = (typeCheckedProgress) => {
    const progress = [];
    const stepDescriptions = Object.keys(typeCheckedProgress);
    for (const stepDescription of stepDescriptions) {
        progress.push({
            stepDescription,
            status: typeCheckedProgress[stepDescription],
        });
    }
    progress.sort(({ stepDescription: a }, { stepDescription: b }) => compareStepDescriptions(a, b));
    return progress;
};
exports.serializeProgressBreakdown = serializeProgressBreakdown;
const findStepWithStatus = (progress, status) => {
    for (const stepDescription in progress) {
        if (progress[stepDescription].status === status) {
            return stepDescription;
        }
    }
    return null;
};
/**
 * Updates {@param progress} in place to reflect {@param newStatus} for {@param step}.
 *
 * @return true if {@param progress} was updated.
 */
const maybeUpdateStatus = (progress, step, newStatus) => {
    // This function may potentially be called once per row of a tape. The `changed` boolean is a hint
    // so that if nothing has changed, the calling code knows it doesn't need to perform expensive
    // work such as a DB call.
    //
    // For the same reason, there's a (possibly premature) optimization here to update the object in
    // place rather than creating a copy.
    let changed = false;
    const prevInProgressStep = findStepWithStatus(progress, 'inProgress');
    const prevStatus = progress[step].status;
    if (prevStatus !== newStatus) {
        progress[step].status = newStatus;
        changed = true;
    }
    if (!lodash_1.default.isNil(prevInProgressStep) && prevInProgressStep !== step) {
        progress[prevInProgressStep].status = 'success';
        changed = true;
    }
    return changed;
};
exports.maybeUpdateStatus = maybeUpdateStatus;
//# sourceMappingURL=PipelineHelpers.js.map